import React, { Component } from 'react';
import { isIPAddress } from 'ip-address-validator';

import WidgetRow from "./widgets/WidgetRow";
import DynamicContentHead from "./DynamicContentHead";
import { toast } from 'react-toastify';

class MyComponent extends Component {

    constructor(props) {
        super(props)
        this.nodes = JSON.parse(localStorage.getItem('nodes')) || []
        if (this.nodes.length === 0) {
            this.nodes = ["cunum.com:3030"]
        }
        this.data = []
        this.state = {
            data: [],
            metrics: [],
            chainId: "atomone-1"
        }
        this.environments = ["testnet", "mainnet"]
        this.proxyURL = "https://proxy.cunum.com?url="
        this.validatorStatus = {}
        this.validatorStake = {}
        this.validatorShards = {}
        this.epochStartHeight = {}
        this.delegators = {}
        this.seatPrice = {}
        this.blockUpdateState = false
        this.lastTime = {}
        this.lastBlocksProcessedTotal = {}
        this.lastTransactionProcessedTotal = {}
        this.blockMisses = 0
    }

    componentDidMount() {
        if (this.nodes.length > 0) {
            toast.info("Loading previously configured nodes, please wait...")
        }
        this.interval = setInterval(this.fetchData.bind(this), 15000)
        this.fetchData()
    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }

    changeInterval(value) {
        clearInterval(this.interval)
        this.interval = setInterval(this.fetchData.bind(this), value)
    }

    changeChainId(chainId) {
        this.setState({ chainId }, () => { this.fetchData() })
    }

    addValidatorStatus(key, value, addInactiveIfNotPresent) {
        let status = this.validatorStatus[key] || []
        if (addInactiveIfNotPresent && status.length == 0) {
            status.push("INACTIVE")
        }
        status.push(value)
        this.validatorStatus[key] = status
    }

    getUpdated() {
        const now = new Date()
        let hours = now.getHours() + ""
        let min = now.getMinutes() + ""
        if (min.length < 2) {
            min = '0' + min
        }
        if (hours.length < 2) {
            hours = '0' + hours
        }
        return "Last updated at " + hours + ":" + min
    }

    fetchSystem() {
        fetch(this.proxyURL + "http://system_monitor:7777/status")
                .then(response => response.json())
                .then(data => this.setState(data))
                .catch(error => console.error(error))
    }

    getData(data, path) {
        const extractedData = data.filter(data => data[0] === path)
        if (extractedData.length > 0) {
            return extractedData[0][1]
        }
        return null
    }

    async getGnoLandMetrics() {
        const statusResponse = await fetch(this.proxyURL + "http://gnoland_validator:26655/status").then(response => response.json()).catch(error => console.error(error))
        const netInfoResponse = await fetch(this.proxyURL + "http://gnoland_validator:26655/net_info").then(response => response.json()).catch(error => console.error(error))
        const blockResponse = await fetch(this.proxyURL + "http://gnoland_validator:26655/block").then(response => response.json()).catch(error => console.error(error))
        if (!statusResponse || !netInfoResponse || !blockResponse) {
            return
        }
        const missedBlock = blockResponse.result.block.last_commit.precommits.filter(pre => pre != null && pre.validator_address == "g1yxkhzstt05j88ckslxfgkd8nc67r5dj8chz4d3").length == 0
        if (missedBlock) {
            this.blockMisses += 1
        }
        return {
            peers: netInfoResponse.result.n_peers,
            stake: statusResponse.result.validator_info.voting_power,
            syncing: statusResponse.result.sync_info.catching_up,
            vpTotal: 0,
            maxBlockLength: statusResponse.result.sync_info.latest_block_height,
            blockHeight: statusResponse.result.sync_info.latest_block_height,
            missedBlocks: String(this.blockMisses),
            network: statusResponse.result.node_info.network,
        }
    }

    async getAtomOneMetrics() {
        const response = await fetch(this.proxyURL + "http://atomone_validator:26660/metrics").then(response => response.text()).catch(error => console.error(error))
        if (!response) {
            return response
        }
        const data = response.split("\n").filter(data => !data.startsWith("#")).map(data => data.split(" "))
        return {
            peers: this.getData(data, 'cometbft_p2p_peers{chain_id="atomone-1"}'),
            stake: this.getData(data, 'cometbft_consensus_validator_power{chain_id="atomone-1",validator_address="D4F81F06AD5ADA0FB484FFBD32B83F3E3F0871D4"}'),
            syncing: this.getData(data, 'cometbft_consensus_state_syncing{chain_id="atomone-1"}') === 0,
            vpTotal: this.getData(data, 'cometbft_consensus_validators_power{chain_id="atomone-1"}'),
            maxBlockLength: this.getData(data, 'cometbft_consensus_validator_last_signed_height{chain_id="atomone-1",validator_address="D4F81F06AD5ADA0FB484FFBD32B83F3E3F0871D4"}'),
            blockHeight: Number(this.getData(data, 'cometbft_consensus_latest_block_height{chain_id="atomone-1"}')),
            missedBlocks: this.getData(data, 'cometbft_consensus_validator_missed_blocks{chain_id="atomone-1",validator_address="D4F81F06AD5ADA0FB484FFBD32B83F3E3F0871D4"}') || 0
        }
    }

    metricsToWidgets(metrics, sys) {
        const cpu = sys.cpu
        const ram = sys.mem
        const updated = this.getUpdated()
        return [
            {
                title: "Peers",
                updated: updated,
                displayValue: metrics.peers,
                value: -1 * metrics.peers,
                greenThreshold: function(val) { return val < 10 },
                yellowThreshold: function(val) { return val < 30 }
            },
            {
                title: "Block Height",
                subtitle: (metrics.maxBlockLength - metrics.blockHeight) + " left",
                value: (metrics.maxBlockLength - metrics.blockHeight),
                updated: updated,
                displayValue: metrics.blockHeight,
                greenThreshold: function(val) { return val < 10 },
                yellowThreshold: function(val) { return val < 30 }
            },
            {
                title: "Voting Power",
                subtitle: metrics.vpTotal === 0 ? "" : Math.round(metrics.stake * 100 / metrics.vpTotal * 100) / 100 + " %",
                updated: updated,
                displayValue: metrics.stake,
                value: metrics.stake,
                greenThreshold: function(val) { return val > 0 }
            },
            {
                title: "CPU",
                updated: updated,
                value: cpu / 100,
                meter: true,
                displayValue: cpu + "%",
                greenThreshold: function(val) { return val < .5 },
                yellowThreshold: function(val) { return val < .75 }
            },
            {
                title: "RAM",
                updated: updated,
                value: ram / 100,
                meter: true,
                displayValue: ram + " %",
                greenThreshold: function(val) { return val < .4 },
                yellowThreshold: function(val) { return val < .7 }
            },
            {
                title: "Block Misses",
                displayValue: metrics.missedBlocks,
                updated: updated,
                value: metrics.missedBlocks,
                greenThreshold: function(val) { return true },
                yellowThreshold: function(val) { return val < 1 }
            }
        ]
    }

    async fetchData() {
        const sys = await fetch(this.proxyURL + "http://system_monitor:7777/v1/status").then(response => response.json()).catch(error => console.error(error))
        const atomOneMetrics = await this.getAtomOneMetrics()
        const gnoLandMetrics = await this.getGnoLandMetrics()
        if (!sys || !atomOneMetrics || !gnoLandMetrics) {
            return
        }

        const atomOneWidgets = this.metricsToWidgets(atomOneMetrics, sys)
        const gnoLandWidgets = this.metricsToWidgets(gnoLandMetrics, sys)
        const data = [
            { node: "AtomOne", environment: "mainnet", widgets: atomOneWidgets, accountId: "AtomOne", version: "2.0.0", syncing: atomOneMetrics.syncing },
            { node: "Gno.land", environment: gnoLandMetrics.network, widgets: gnoLandWidgets, accountId: "GnoLand", version: "test6.3", syncing: gnoLandMetrics.syncing }
        ]
        this.setState({ data })
    }

    formatStake(stake) {
        return Math.round(stake / 1000000000000000000000000)
    }

    render() {
        return (
            <div className="content">
                <DynamicContentHead title={"Validator Monitoring"}>
                    <div className="dashboard-form">
                        <label htmlFor="update_interval">Update Interval</label>
                        <select id="update_interval" onChange={(e) => this.changeInterval(e.target.value)}>
                            <option value="15000" selected>15s</option>
                            <option value="30000">30s</option>
                            <option value="60000">1min</option>
                            <option value="300000">5min</option>
                        </select>
                    </div>
                </DynamicContentHead>
                <div className="dashboard-content half-padding-top">
                    { this.nodes.length > 0 && this.state.data.length === 0 && (
                        <div className="spinner">
                          <div className="lds-ring-black"><div></div><div></div><div></div><div></div></div>
                          <div className="loading-text">Loading...</div>
                        </div>
                    )}
                    { this.state.data && (
                      this.state.data.map((row, rowIndex) => {
                        return <WidgetRow
                            row={row}
                            key={rowIndex}
                        />
                      })
                    )}
                </div>
            </div>
        );
    }
}

export default MyComponent;
